import { PaymentLayout } from 'components/layouts';
import { PaymentPage } from 'components/pages/Payment/PaymentPage';
import { EntryPoint, NextPageWithLayout } from 'utils/nextTypes';

const DepositPage: NextPageWithLayout = function DepositPage() {
  return <PaymentPage />;
};

DepositPage.getLayout = (page) => {
  return <PaymentLayout>{page}</PaymentLayout>;
};
DepositPage.entryPointType = EntryPoint.PUBLIC;

export default DepositPage;
